export default "__VITE_ASSET__a37e5b47__"